{
  "version": 1,
  "asset_id": "5544a964-4fda-4476-90da-c5b2b9a37cbd",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/5544a964-4fda-4476-90da-c5b2b9a37cbd/timothy-ng-96.jpg",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/5544a964-4fda-4476-90da-c5b2b9a37cbd/timothy-ng-96.jpg",
  "original_filename": "timothy-ng-96.jpg",
  "size": 3071,
  "content_type": "image/jpeg",
  "created_at": "2026-07-29T18:51:30Z"
}
